/// <amd-module name="Build/Admin/PoolsList/Components/PipelinePermissionsSettings" />
import * as React from "react";

import { Checkbox } from "VSSUI/Checkbox";
import { ConditionalChildren } from "VSSUI/ConditionalChildren";

import * as Resources from "Build/Admin/PoolsList/Resources";

export interface IPipelinePermissionsSettingsProps {
    authorizeAllPipelines: boolean;
    autoProvisionProjectPools: boolean;
    showAuthorizeAllPipelinesOption: boolean;
    showAutoProvisionOption: boolean;
    disableAllPipelinesSetting: boolean;
    onSettingsChanged(authorizeAllPipelines: boolean, autoProvisionProjectPools: boolean): void;
}

export class PipelinePermissionsSettings extends React.PureComponent<IPipelinePermissionsSettingsProps> {
    constructor(props: IPipelinePermissionsSettingsProps) {
        super(props);
    }

    public render(): JSX.Element {
        return (
            <div className="pipeline-permissions-section">
                <div className="pool-setting-label">
                    {Resources.PipelinePermissions}
                </div>
                <ConditionalChildren renderChildren={this.props.showAuthorizeAllPipelinesOption}>
                    <Checkbox
                        className="authorize-pipelines-checkbox"
                        checked={this.props.authorizeAllPipelines}
                        disabled={this.props.disableAllPipelinesSetting}
                        onChange={(ev, authorizeAllPipelines) => this.props.onSettingsChanged(authorizeAllPipelines, this.props.autoProvisionProjectPools)}
                        label={Resources.PipelineSecurityAuthorizeAll} />
                </ConditionalChildren>
                <ConditionalChildren renderChildren={this.props.showAutoProvisionOption}>
                    <Checkbox
                        className="auto-provision-project-pools-checkbox"
                        checked={this.props.autoProvisionProjectPools}
                        onChange={(ev, autoProvisionProjectPools) => this.props.onSettingsChanged(this.props.authorizeAllPipelines, autoProvisionProjectPools)}
                        label={Resources.AutoProvisionProjectPools} />
                </ConditionalChildren>
            </div>
        );
    }
}
